export default __webpack_public_path__ + "static/media/background-the-end.b3c5f787.svg";